import React, {useRef} from 'react'
import {Icon, IconName} from "./Icon"
import './PreviewButton.less'

interface PreviewButtonProps {
  onPreview: () => void
  tooltipText?: string
  className?: string
}

export const PreviewButton: React.FC<PreviewButtonProps> = ({
  onPreview,
  tooltipText = 'Preview',
  className = ''
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    onPreview()
  }

  return (
    <div className={`preview-button-container ${className}`}>
      <button
        ref={buttonRef}
        className="preview-button"
        onMouseDown={handleClick}
        aria-label="Preview"
        title={tooltipText}
      >
        <Icon
          name={IconName.Preview}
          className="preview-icon"
          width="20"
          height="20"
        />
      </button>
    </div>
  )
}
